import clsx from 'clsx'

import Badge from '@ingka/badge'

import { useTranslate } from '@/hooks/use-translate'

import { missingBadge } from './missing-badge.module.css'

type MissingBadgeProps = {
  className?: string
  label?: string
  severity: 'error' | 'info' | 'warning'
}

const colourMap = {
  error: 'red',
  info: 'blue',
  warning: 'orange',
} as const satisfies Record<MissingBadgeProps['severity'], string>

export function MissingBadge({ className, label, severity }: MissingBadgeProps) {
  const { translateString } = useTranslate()
  const displayLabel = label ?? translateString('common.missing')

  return (
    <Badge className={clsx(missingBadge, className)} colour={colourMap[severity]} label={displayLabel} size="small" />
  )
}
